import axios from "axios";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListKegiatan from "./ListKegiatan";

const AddKegiatan = () => {
  const [judul, setJudul] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [tanggal, setTanggal] = useState("");
  const [link, setLink] = useState("");
  const [mediaType, setMediaType] = useState("image");
  const [files, setFiles] = useState([]);
  const [preview, setPreview] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles([...files, ...selectedFiles]);
    setPreview([
      ...preview,
      ...selectedFiles.map((f) => ({
        file: f,
        url: URL.createObjectURL(f),
      })),
    ]);
  };

  const handleRemove = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);

    const newPreview = [...preview];
    URL.revokeObjectURL(newPreview[index].url);
    newPreview.splice(index, 1);
    setPreview(newPreview);
  };

  const handleSubmit = async () => {
    if (!judul || !deskripsi || !tanggal) {
      toast.error("Lengkapi semua field terlebih dahulu.");
      return;
    }

    if (mediaType === "video" && !link && files.length === 0) {
      toast.error("Upload video atau isi link video.");
      return;
    }

    if (mediaType === "image" && files.length === 0) {
      toast.error("Minimal satu gambar harus diunggah.");
      return;
    }

    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("deskripsi", deskripsi);
    formData.append("tanggal", tanggal);
    if (mediaType === "video" && link) {
      formData.append("link", link);
    }
    files.forEach((f) => formData.append("files", f));

    try {
      setIsUploading(true);
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/kegiatan`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      toast.success("Kegiatan berhasil ditambahkan");
      setJudul("");
      setDeskripsi("");
      setTanggal("");
      setLink("");
      setFiles([]);
      setPreview([]);
    } catch (err) {
      toast.error("Gagal menambahkan kegiatan.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto bg-white rounded shadow-md relative">
      <ToastContainer />
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Tambah Kegiatan
      </h2>

      <div className="space-y-4">
        <div>
          <label className="block font-medium">Judul:</label>
          <input
            className="w-full border border-gray-300 rounded px-3 py-2"
            value={judul}
            onChange={(e) => setJudul(e.target.value)}
          />
        </div>

        <div>
          <label className="block font-medium">Deskripsi:</label>
          <textarea
            className="w-full border border-gray-300 rounded px-3 py-2"
            value={deskripsi}
            onChange={(e) => setDeskripsi(e.target.value)}
          />
        </div>

        <div>
          <label className="block font-medium">Tanggal:</label>
          <input
            type="date"
            className="w-full border border-gray-300 rounded px-3 py-2"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
          />
        </div>

        <div>
          <label className="block font-medium">Jenis Media:</label>
          <select
            className="w-full border border-gray-300 rounded px-3 py-2"
            value={mediaType}
            onChange={(e) => {
              setMediaType(e.target.value);
              setLink("");
              setFiles([]);
              setPreview([]);
            }}
          >
            <option value="image">Gambar</option>
            <option value="video">Video</option>
          </select>
        </div>

        {mediaType === "video" && (
          <div>
            <label className="block font-medium">Link (opsional):</label>
            <input
              className="w-full border border-gray-300 rounded px-3 py-2"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </div>
        )}

        <div>
          <label className="block font-medium">
            Upload {mediaType === "image" ? "Gambar" : "Video"}:
          </label>
          <input
            type="file"
            accept="image/*,video/mp4"
            multiple
            onChange={handleFileChange}
          />
        </div>

        <div className="grid grid-cols-2 gap-4 mt-4">
          {preview.map((item, index) => (
            <div key={index} className="relative">
              {item.file.type.startsWith("image") ? (
                <img
                  src={item.url}
                  className="w-full h-40 object-cover rounded"
                  alt="preview"
                />
              ) : (
                <video
                  src={item.url}
                  controls
                  className="w-full h-40 rounded bg-black"
                />
              )}
              <button
                onClick={() => handleRemove(index)}
                className="absolute top-1 right-1 bg-red-500 text-white px-2 py-1 rounded"
              >
                Hapus
              </button>
            </div>
          ))}
        </div>

        <button
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition disabled:opacity-60"
          onClick={handleSubmit}
          disabled={isUploading}
        >
          {isUploading ? "Mengunggah..." : "Simpan"}
        </button>
      </div>

      {isUploading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded shadow-md text-center">
            <p className="text-lg font-semibold mb-2">Mengunggah...</p>
            <p>Mohon tunggu, media sedang diproses.</p>
          </div>
        </div>
      )}

      <div className="mt-10">
        <ListKegiatan />
      </div>
    </div>
  );
};

export default AddKegiatan;
